import { render } from "./ShareRequestListItemSent.vue?vue&type=template&id=3e72e946"
import script from "./ShareRequestListItemSent.vue?vue&type=script&lang=js"
export * from "./ShareRequestListItemSent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__